/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";
import "./styles.less";
export const DatabasePageCard = ({
  title = "",
  contentList = [],
  icon,
  docLink,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`databasePage-card`}>
      <div className="title-top">
        <div className="title-icon">
          <img src={icon} alt="authing" />
        </div>
        <div className="title-text">{title}</div>
      </div>
      <div className="database-list-warp">
        {contentList.map((item, index) => (
          <>
            <div className="item-list-warp">
              <div className="item-list">{item}</div>
            </div>
          </>
        ))}
      </div>

      <div>
        <Link href={docLink} target="_blank">
          {t("common.button.linkDoc")}
        </Link>
      </div>
    </div>
  );
};
export const DatabasePageSolutions = () => {
  const { t } = useTranslation();
  const VerifyPageCardOne = {
    title: t("learn.databasePage.solution-docs.item1.title"),
    icon: "//files.authing.co/authing-website/sso-icon-storage.png",
    contentList: [t("learn.databasePage.solution-docs.item1.descript")],
    docLink:
      "https://docs.authing.cn/v2/guides/database-connection/overview.html",
  };
  const VerifyPageCardTwo = {
    title: t("learn.databasePage.solution-docs.item2.title"),
    icon: "//files.authing.co/authing-website/page-link-icon-database.svg",
    contentList: [t("learn.databasePage.solution-docs.item2.descript")],
    docLink:
      "https://docs.authing.cn/v2/guides/database-connection/overview.html",
  };
  const VerifyPageCardThree = {
    title: t("learn.databasePage.solution-docs.item3.title"),
    icon: "//files.authing.co/authing-website/guard-function-icon-4.png",
    contentList: [t("learn.databasePage.solution-docs.item3.descript")],
    docLink:
      "https://docs.authing.cn/v2/guides/database-connection/overview.html",
  };

  return (
    <div className="databasePage-content-solution">
      <div className="verify-content-sdk-title">
        {t("learn.databasePage.solution-docs.title")}
      </div>
      <div className="verify-content-card-warp">
        <DatabasePageCard {...VerifyPageCardOne} />
        <DatabasePageCard {...VerifyPageCardTwo} />
        <DatabasePageCard {...VerifyPageCardThree} />
      </div>
    </div>
  );
};
